import { render, staticRenderFns } from "./ChatComposer.vue?vue&type=template&id=33e0e76c&scoped=true&"
import script from "./ChatComposer.vue?vue&type=script&lang=js&"
export * from "./ChatComposer.vue?vue&type=script&lang=js&"
import style0 from "./ChatComposer.vue?vue&type=style&index=0&id=33e0e76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e0e76c",
  null
  
)

export default component.exports